import { render, staticRenderFns } from "./VisitCreateDetailMain.vue?vue&type=template&id=0c10d2c8"
import script from "./VisitCreateDetailMain.vue?vue&type=script&lang=ts"
export * from "./VisitCreateDetailMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports